import { connect } from 'react-redux';
import * as actions from '../../actions/group';
import Group from '../../components/group/Group';

const mapStateToProps = ({ group }) => ({
  initialValues: group.group,
});

const mapDispatchToProps = dispatch => ({
  didMount: id => dispatch(actions.group(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Group);
